import React from "react";
import PortfolioBlock from "./PortfolioBlock";
import { Box, Typography, Grid } from "@mui/material";
import { info } from "../../info/Info";

export default function Portfolio({ innerRef }) {
  return (
    <Box
      id="portfolio"
      ref={innerRef}
      sx={{
        py: 12,
        px: {
          xs: 2,
          md: 6,
        },
      }}
    >
      {/* HEADER */}

      <Box textAlign="center" mb={10}>
        <Typography
          sx={{
            fontSize: {
              xs: "2.5rem",
              md: "4rem",
            },
            fontWeight: 800,
            mb: 2,
          }}
        >
          Mobile Apps
        </Typography>

        <Typography
          sx={{
            opacity: 0.7,
            maxWidth: "700px",
            margin: "auto",
            lineHeight: 1.8,
          }}
        >
          A collection of Flutter applications focused on beautiful UI, scalable
          architecture, and smooth user experiences.
        </Typography>
      </Box>

      {/* PROJECTS */}

      <Grid container spacing={5} alignItems="flex-start">
        {info.portfolio.map((project, index) => (
          <Grid
            item
            xs={12}
            md={6}
            key={index}
            sx={{
              display: "flex",
            }}
          >
            <PortfolioBlock
              title={project.title}
              description={project.description}
              image={project.image}
              icon={project.icon}
              tech={project.tech}
              features={project.features}
              googlePlay={project.googlePlay}
              appStore={project.appStore}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}